import {useContext, useState} from "react";
import {shareMarketplaceAPI} from "../common/api/shareMarketplaceAPI";
import {createURLQueryFromParams} from "../common/api/apiUtil";
import {useKeycloakFunctions} from "./useKeycloakFunctions";
import {API_SHARE_MARKETPLACE_OFFERS, API_SHARE_MARKETPLACE_OFFERS_SELLERS, API_SHARE_MARKETPLACE_ADMIN_OFFERS} from "../common/api/apiConstants";
import {LocaleContext} from "../store/providers/LocaleProvider";

export const useMarketplaceOfferSeller = () => {

    const {initialized, authenticated} = useKeycloakFunctions();
    const {localeUppercaseUnderscore} = useContext(LocaleContext)[0];


    const [offer, setOffer] = useState(undefined);
    const [loadingOffer, setLoadingOffer] = useState(false);
    const [errorOffer, setErrorOffer] = useState(null);

    const [offerAdmin, setOfferAdmin] = useState(undefined);
    const [loadingOfferAdmin, setLoadingOfferAdmin] = useState(false);
    const [errorOfferAdmin, setErrorOfferAdmin] = useState(null);

    const getOfferSeller = (locale, offerId) => {

        if (offerId && initialized && authenticated) {
            setLoadingOffer(true);

            let params = {};
            params.locale = locale || "en_GB";

            shareMarketplaceAPI.get(API_SHARE_MARKETPLACE_OFFERS
                + "/" + offerId + API_SHARE_MARKETPLACE_OFFERS_SELLERS
                + createURLQueryFromParams(params), {redirectOnError: true})
                .then(res => res.data)
                .then(response => {
                    setLoadingOffer(false);
                    if (response) {
                        setOffer(response);
                    }
                })
                .catch(err => {
                    // In case of 401 the user is redirected to the homepage
                    if (401 !== err.response.status) {
                        setLoadingOffer(false);
                        setErrorOffer(err);
                    }
                });
        }
    };

    const getOfferAdmin = (offerId) => {

        if (offerId && initialized && authenticated) {
            setLoadingOfferAdmin(true);

            let params = {};
            params.locale = localeUppercaseUnderscore || "en_GB";

            shareMarketplaceAPI.get(API_SHARE_MARKETPLACE_ADMIN_OFFERS
                + "/" + offerId
                + createURLQueryFromParams(params), {redirectOnError: true})
                .then(res => res.data)
                .then(response => {
                    setLoadingOfferAdmin(false);
                    if (response) {
                        setOfferAdmin(response);
                    }
                })
                .catch(err => {
                    // In case of 401 the user is redirected to the homepage
                    if (401 !== err.response.status) {
                        setLoadingOfferAdmin(false);
                        setErrorOfferAdmin(err);
                    }
                });
        }
    };

    return {
        getOfferSeller,
        offer,
        setOffer,
        loadingOffer,
        errorOffer,

        getOfferAdmin,
        offerAdmin,
        loadingOfferAdmin,
        errorOfferAdmin,
    };
};
